export function changeAnalysesCountInHeader(analysesCount: number) {
  const countIconElement: HTMLElement | null = document.querySelector('.add-point-to-cart')

  if (countIconElement) {
    if (analysesCount === 0) {
      countIconElement.classList.add('d-none')
      return
    }

    countIconElement.innerText = analysesCount > 9 ? '9+' : analysesCount.toString()
  }
}
